import React, { useState, useEffect } from 'react';
import JoinTelegramModal from '../../../../components/common/joinTelegramModal';
import GaEventsTracker from "../../../../components/common/GaEventsTracker";

const MobileTab = ({ OnClickPopHandle }) => {

    const useGaEventsTracker = GaEventsTracker("External Links")
    // const [openLive, setOpenLive] = useState(false)

    const AndroidDownload = () => {
        OnClickPopHandle("https://play.google.com/store/apps/details?id=com.moomoo.trade", true)
        useGaEventsTracker('event', 'downloadApp', { 'event_category': 'Telegram' })
    }

    const AppleDownload = () => {
        OnClickPopHandle("https://apps.apple.com/my/app/moomoo-stocks-investments/id1440255819", true)
        useGaEventsTracker('event', 'downloadApp', { 'event_category': 'Telegram' })
    }

    const ClickhereM = () => {
        OnClickPopHandle("https://www.moomoo.com/community/profile/macquarie-warrants-malaysia-80001374", true)
        useGaEventsTracker('event', 'openOnMobile', { 'event_category': 'Telegram' })
    }

    return (
        <>
            <div className="activeM">
                <div className="row step-row">
                    <div className="col-md-1   col-xs-3">
                        <img src="/img/moocommunity/MooComm_Sign_Up_1.png" style={{ width: '25px', height: '25px' }} />
                    </div>
                    <div className="col-md-11   col-xs-9">
                        <p className="howJoinSubTitle">
                            Download the Moomoo application
                            <br />
                            <em className="small">
                                Skip this step if you already have the app
                            </em>
                        </p>
                        <div>
                            <span
                                className="androidDownload broker_img "
                                style={{ marginRight: "5px" }}
                                onClick={AndroidDownload}
                            >
                                <img
                                    className="forMDimg"
                                    src="/img/moocommunity/1737361703152.png"
                                />
                            </span>
                            <span
                                className="appleDownload broker_img"
                                onClick={AppleDownload}
                            >
                                <img
                                    className="forMDimg"
                                    src="/img/moocommunity/17373617946522.png"
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <div className="row step-row">
                    <div className="col-md-1   col-xs-3">
                        <img src="/img/moocommunity/MooComm_Sign_Up_2.png" style={{ width: '25px', height: '25px' }} />
                    </div>
                    <div className="col-md-11  col-xs-9">
                        <p className="howJoinSubTitle">
                            Sign up with your mobile number/email address
                        </p>
                        <img
                            className="for-img forMDimg"
                            src="/img/moocommunity/MooComm_Sign_Up_Mobile_1.png"
                        />
                    </div>
                </div>
                <div className="row step-row">
                    <div className="col-md-1  col-xs-3">
                        <img src="/img/moocommunity/MooComm_Sign_Up_3.png" style={{ width: '25px', height: '25px' }} />
                    </div>
                    <div className="col-md-11  col-xs-9">
                        <p className="howJoinSubTitle">
                            Search “Macquarie Warrants Malaysia” on the app and
                            click on “Mooers”, or{" "}
                            <span
                                className="clickhereM broker_img"
                                style={{ color: "#F17322" }}
                                onClick={ClickhereM}
                            >
                                click here
                            </span>
                        </p>
                        <img
                            id="mobile-3"
                            className="for-img forMDimg"
                            src="/img/moocommunity/MooComm_Sign_Up_Mobile_2.png"
                        />
                    </div>
                </div>
                <div className="row step-row">
                    <div className="col-md-1  col-xs-3">
                        <img src="/img/moocommunity/MooComm_Sign_Up_4.png" style={{ width: '25px', height: '25px' }} />
                    </div>
                    <div className="col-md-11  col-xs-9">
                        <p className="howJoinSubTitle">
                            Tap on the +Follow button next to the account name.
                        </p>
                        <img
                            id="mobile-3"
                            className="for-img forMDimg"
                            src="/img/moocommunity/MooComm_Sign_Up_Mobile_3.png"
                        />
                    </div>
                </div>
            </div>
        </>
    )
};

export default MobileTab;